module.exports = __webpack_public_path__ + "img/bglogin.ed1aae3f.jpeg";